export const stringsKey = "SendMessageWidget";
export const englishStrings = {
	widgetLabel: "Label Name",
	messageText: "Message Text",
	messageAudio: "Message Audio",
	labelErrorMessage: "The label field is required.",
};
